import React, { useEffect, useState } from 'react';
import { getAllPortfolios } from '../../common/portfolioStore';

function getScreenshot(url) {
  if (!url) return null;
  return `https://image.thum.io/get/width/600/crop/800/${url}`;
}

function PortfolioCard({ item, index }) {
  const colClass =
    index % 5 === 2 || index % 5 === 5 ? 'col-lg-8 offset-lg-2' : 'col-lg-5';
  const offset =
    index % 5 === 1 || index % 5 === 4 ? 'offset-lg-1' : '';

  const imgSrc = item.coverImg || getScreenshot(item.url);

  return (
    <div className={`${colClass} ${offset}`}>
      <div className="item mb-80 mt-40">
        <div className="img" style={{ overflow: 'hidden', borderRadius: '8px' }}>
          {imgSrc ? (
            <a href={item.url} target="_blank" rel="noopener noreferrer">
              <img
                src={imgSrc}
                alt={item.title}
                style={{ width: '100%', display: 'block', transition: 'transform 0.4s ease' }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
              />
            </a>
          ) : (
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '260px',
                background: 'rgba(255,255,255,0.05)',
                borderRadius: '8px',
                color: 'rgba(255,255,255,0.3)',
                fontSize: '14px',
              }}
            >
              {item.url}
            </a>
          )}
        </div>
        <div className="cont d-flex align-items-end mt-30">
          <div>
            {item.category && (
              <span className="p-color mb-5 sub-title">{item.category}</span>
            )}
            <h6>{item.title}{item.titleHighlight ? ` – ${item.titleHighlight}` : ''}</h6>
          </div>
          <div className="ml-auto">
            <a href={item.url} target="_blank" rel="noopener noreferrer">
              <span className="ti-arrow-top-right"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

function Portfolio() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllPortfolios()
      .then((data) => setItems(data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <section className="work-grid pt-60 pb-60">
        <div className="container">
          <p className="p-color text-center">Yükleniyor...</p>
        </div>
      </section>
    );
  }

  if (items.length === 0) {
    return (
      <section className="work-grid pt-60 pb-60">
        <div className="container">
          <p className="p-color text-center">Henüz portfolio projesi eklenmemiş.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="work-grid pt-60 pb-60">
      <div className="container">
        <div className="row">
          {items.map((item, i) => (
            <PortfolioCard key={item.id} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
